import script from "./CategoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryList.vue?vue&type=script&setup=true&lang=js"

import "./CategoryList.vue?vue&type=style&index=0&id=a9b895e8&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b895e8"]])

export default __exports__